import { ApiService } from "$/services/ApiService.js";
import { ServiceConsts } from "$/services/ServiceConsts.js";
import { LocalStorage } from "$/services/LocalStorage.js";
export class ClusterService {
    static async getBaseUrl() {
        let tenant = await LocalStorage.get("activeTenant");
        return `${ServiceConsts.API_URL}/tenants/${tenant.id}/clusters`;
    }
    static async getClusters() {
        let url = await this.getBaseUrl();
        return await ApiService.get(url);
    }
    static async getClustersByTenantId(tenantId) {
        let url = `${ServiceConsts.API_URL}/tenants/${tenantId}/clusters`;
        return await ApiService.get(url);
    }
    static async createCluster(cluster) {
        let url = await this.getBaseUrl();
        return await ApiService.post(url, cluster);
    }
    static async updateCluster(cluster) {
        let url = await this.getBaseUrl();
        return await ApiService.patch(`${url}/${cluster.id}`, cluster);
    }
    static async deleteCluster(cluster) {
        let url = await this.getBaseUrl();
        return await ApiService.delete(`${url}/${cluster.id}`);
    }
    static async leaveCluster(clusterId) {
        let url = await this.getBaseUrl();
        return await ApiService.post(`${url}/${clusterId}/leave`);
    }
    static async reorderClusters(clustersOrder) {
        let url = await this.getBaseUrl();
        return await ApiService.post(`${url}/reorder`, clustersOrder);
    }
    static async createClusterRole(clusterRole, clusterId) {
        let url = await this.getBaseUrl();
        return await ApiService.post(`${url}/${clusterId}/roles`, clusterRole);
    }
    static async updateClusterRole(clusterRole, clusterId) {
        let url = await this.getBaseUrl();
        return await ApiService.put(`${url}/${clusterId}/roles/${clusterRole.id}`, clusterRole);
    }
    static async deleteClusterRole(clusterRoleId, clusterId) {
        let url = await this.getBaseUrl();
        return await ApiService.delete(`${url}/${clusterId}/roles/${clusterRoleId}`);
    }
}
